import { Link } from "react-router";

import { ROUTES } from "@/constants/routes";

export const NotFound = () => (
	<div className="flex h-dvh flex-col items-center justify-center gap-3 p-6 text-center">
		<h1 className="text-xl font-semibold text-primary">Page not found</h1>
		<Link
			className="text-sm text-secondary underline"
			to={ROUTES.ORGANIZATION_LOCATIONS}
		>
			Back to Location Management
		</Link>
	</div>
);
